import {
  forwardRef,
  type ElementType,
  type ComponentPropsWithoutRef,
} from "react";
import { cn } from "@/lib/utils";

type BarControlProps = {
  as?: ElementType;
} & ComponentPropsWithoutRef<"div">;

export const BarControl = forwardRef<HTMLElement, BarControlProps>(
  ({ as, className, ...props }, ref) => {
    const Comp = as || "button";
    return (
      <Comp
        ref={ref as React.Ref<never>}
        className={cn(
          "flex items-center gap-1.5 bg-white/[0.05] rounded-lg px-2.5 h-9 border border-white/[0.07] hover:bg-white/[0.10] hover:border-white/[0.12] transition-all duration-200",
          className,
        )}
        {...props}
      />
    );
  },
);

BarControl.displayName = "BarControl";
